import user from './user/i18nUser'
import module from './module/i18nModule'
import login from './auth/i18nLogin'

const app = {
    en: {
        businessLine: "Business Line",
        contracts: "Contracts",
        updated: "updated",
        created: "created",
        forms: "Forms",
        file: 'Upload file', //TODO Mudar esse File para um arquivo melhor
        filters: "Filters",
        sgsHome: "SGS Home",
        sgsAroundTheWorld: "SGS around the world",
        latitude: "Latitude",
        longitude: "Longitude",
        charges: "Billet charges",
        dealership: "Billet dealership",
        yourPasswordIsExpired: 'Your password is expired, please change your password to gain access to the system!',
        newPasswordCanNotBeEqualToACurrentPassword: "New password can not be equal to a current password!",
        newPasswordAndRepeatPasswordAreDifferentValues: 'New password and repeat password are different values!',
        savedPasswordWithSuccess: "Saved password with success",
        passwordUpdatedWithSuccess: "Password updated with success",
        cancel: "Cancel",
        continue: "Continue",
        back: "Back",

        ...user.en,
        ...module.en,
        ...login.en,
    },
    pt: {
        businessLine: "Business Line",
        contracts: "Contratos",
        updated: "atualizado",
        created: "criado",
        forms: "Forms",
        file: 'Anexar', // TODO Mudar esse File para um arquivo melhor
        filters: "Filtros",
        sgsHome: "SGS Home",
        sgsAroundTheWorld: "SGS ao redor do mundo",
        latitude: "Latitude",
        longitude: "Longitude",
        charges: "Boleto de cobranças",
        dealership: "Boleto de concessionária",
        yourPasswordIsExpired: 'Sua senha está expirada, por favor mude a senha para ter acesso ao sistema!',
        newPasswordCanNotBeEqualToACurrentPassword: "Nova senha não pode ser igual a senha atual!",
        newPasswordAndRepeatPasswordAreDifferentValues: 'Nova senha e repetir nova senha são valores diferentes!',
        savedPasswordWithSuccess: "Senha salva com sucesso",
        passwordUpdatedWithSuccess: "Senha alterada com sucesso",
        cancel: "Cancelar",
        continue: "Continuar",
        back: "Voltar",

        ...user.pt,
        ...module.pt,
        ...login.pt,
    },
    es: {
        businessLine: "Business Line",
        contracts: "Contratos",
        updated: "actualizado",
        created: "creado",
        forms: "Forms",
        file: 'Anexar', // TODO Mudar esse File para um arquivo melhor
        filters: "Filtros",
        sgsHome: "SGS Home",
        sgsAroundTheWorld: "SGS en todo el mundo",
        latitude: "Latitud",
        longitude: "Longitud",
        charges: "Billete de conbranza",
        dealership: "Billete de la concessionaria",
        yourPasswordIsExpired: 'Su contraseña ha caducado. ¡Cambie su contraseña para acceder al sistema!',
        newPasswordCanNotBeEqualToACurrentPassword: '¡Nueva contraseña no puede ser igual a contraseña actual!',
        newPasswordAndRepeatPasswordAreDifferentValues: '¡Nueva contraseña y contraseña de repetición son valores diferentes!',
        savedPasswordWithSuccess: "Contraseña guardada con éxito",
        passwordUpdatedWithSuccess: "Contraseña alterada con éxito",
        cancel: "Cancelar",
        continue: "Continuar",
        back: "Volar",

        ...user.es,
        ...module.es,
        ...login.es,
    }
};

export default {
    ...app
}



// WEBPACK FOOTER //
// ./src/app/i18nApp.js